import { OfferEntry } from './OfferEntry'

export enum Type {
  INCOME = 'INCOME',
  EXPENSE = 'EXPENSE',
}

export type Offer = {
  uuid?: string

  type: Type
  companyUUID: string
  entryUUIDList?: string[]
  fileName?: string
  fileKey?: string

  // dynamic properties
  entries?: OfferEntry[]
  fileURL?: string
}
